import '@/styles/index.css';
import ReactDOM from 'react-dom';
import App from './App.jsx';
import {initSentry} from '@/utils/sentry';

initSentry();

const rootElement = document.getElementById('root');

const flowName = rootElement.attributes['flow']?.value;
const maxHeight = rootElement.attributes['max-height']?.value;

ReactDOM.render(<App maxHeight={maxHeight} flowName={flowName} />, rootElement);
